"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeErrorLogger = exports.addErrorLogger = void 0;
var SHOW_ERROR_BANNER_FOR = 'endpoints_resolution_error';
var errorHandler = function errorHandler(event) {
  if ((event === null || event === void 0 ? void 0 : event.reason.toString().indexOf(SHOW_ERROR_BANNER_FOR)) !== -1) {
    showErrorBanner();
  }
};
var addErrorLogger = function addErrorLogger() {
  window.addEventListener('unhandledrejection', errorHandler);
};
exports.addErrorLogger = addErrorLogger;
var removeErrorLogger = function removeErrorLogger() {
  window.removeEventListener('unhandledrejection', errorHandler);
};
exports.removeErrorLogger = removeErrorLogger;
var showErrorBanner = function showErrorBanner() {
  // eslint-disable-next-line max-len
  var errorBannerStyle = "<style>a, a:visited, a:hover {text-decoration: underline; color: #000000;}.error-banner{ background-color: #FAD7D7;border: 1px solid #DE8E97;border-radius: 2px; padding: 12px 16px 12px 16px;font-weight: 400; font-size: 16px; width: 30%; margin: auto;display: flex; margin-top: 24px;}.error-icon{width:50px; height: 40px; margin-right: 20px; }</style>";
  var errorMessage = document.createElement('div');
  errorMessage.innerHTML = "Login to Hapag-Lloyd Business suite is currently not available. Please try again later. If the issue persists,  contact our <a href=\"https://www.hapag-lloyd.com/en/meta/quick-access-to-contact.html\">technical support.</a>";
  errorMessage.classList.add('error-message');
  var errorIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  errorIcon.classList.add('error-icon');
  errorIcon.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.0001 2.45612C11.5001 2.45612 11.0001 2.64612 10.5901 3.04612L2.59006 11.0461C1.80006 11.8261 1.80006 13.0861 2.59006 13.8661L10.5901 21.8661C11.3701 22.6561 12.6301 22.6561 13.4101 21.8661L21.4101 13.8661C22.2001 13.0861 22.2001 11.8261 21.4101 11.0461L13.4101 3.04612C13.0001 2.64612 12.5001 2.45612 12.0001 2.45612ZM11.0001 7.45612C11.0001 6.90383 11.4478 6.45612 12.0001 6.45612C12.5523 6.45612 13.0001 6.90383 13.0001 7.45612V13.4561C13.0001 14.0084 12.5523 14.4561 12.0001 14.4561C11.4478 14.4561 11.0001 14.0084 11.0001 13.4561V7.45612ZM11.0001 17.4561C11.0001 16.9038 11.4478 16.4561 12.0001 16.4561C12.5523 16.4561 13.0001 16.9038 13.0001 17.4561C13.0001 18.0084 12.5523 18.4561 12.0001 18.4561C11.4478 18.4561 11.0001 18.0084 11.0001 17.4561Z" fill="#B00020"/></svg>';
  var errorBanner = document.createElement('div');
  errorBanner.classList.add('error-banner');
  errorBanner.insertAdjacentElement('beforeend', errorIcon);
  errorBanner.insertAdjacentElement('beforeend', errorMessage);
  document.body.insertAdjacentHTML('beforeend', errorBannerStyle);
  document.body.insertAdjacentElement('beforeend', errorBanner);
};
//# sourceMappingURL=error.js.map